import Vue from 'vue';
import Config from '../configuration';

export default {
    namespaced: true,
    mutations: {

    },
    getters: {

    },
    actions: {
        createFactorClaim (context, payload)
        {
            let self = this;
            return new Promise(function (resolve, reject)
            {
                Vue.axios.post(Config.GetUrl(Config.kritaApi) + 'application/' , {SelectedBankClaims: payload.SelectedBankClaims, ClaimantId: self.state.userInfo.SelectedClaimant.ClaimantId, NoRefactoringRequest: payload.NoRefactoringRequest}, {
                }).then(function (response)
                {
                    if (response.data.HasError)
                    {
                        reject(new Error('no results'));
                    }
                    else
                    {
                        resolve(response);
                    }
                }, () =>
                {
                    reject(new Error('no results'));
                });
            });
        },
        getApplicationReport (context, payload)
        {
            let self = this;

            return new Promise(function (resolve, reject)
            {
                Vue.axios.put(Config.GetUrl(Config.kritaApi) + 'application/' , {ClaimantId: self.state.userInfo.SelectedClaimant.ClaimantId, Current :payload.page, RowCount: payload.rowsPerPage, Sort: payload.sort, Selection: payload.selection, From: payload.from, To: payload.to, Search: payload.search}, {
                }).then(function (response)
                {
                    if (response.data.HasError)
                    {
                        reject(new Error('no results'));
                    }
                    else
                    {
                        resolve(response.data.Data);
                    }
                }, () =>
                {
                    reject(new Error('no results'));
                });
            });
        },
        getApplicationClaims (context, payload)
        {
            return new Promise(function (resolve, reject)
            {
                Vue.axios.put(Config.GetUrl(Config.kritaApi) + 'application/' + payload.id + '/Factorings', {Current :payload.page, RowCount: payload.rowCount, Sort: payload.sort, ApplicationId: payload.id, Search: payload.search }, {
                }).then(function (response)
                {
                    if (response.data.HasError)
                    {
                        reject(new Error('no results'));
                    }
                    else
                    {
                        resolve(response.data.Data);
                    }
                }, () =>
                {
                    reject(new Error('no results'));
                });
            });
        },
        getApplicationRefactorings (context, payload)
        {
            return new Promise(function (resolve, reject)
            {
                Vue.axios.put(Config.GetUrl(Config.kritaApi) + 'application/' + payload.id + '/Refactorings', {Current :payload.page, RowCount: payload.rowCount, Sort: payload.sort, ApplicationId: payload.id, Search: payload.search }, {
                }).then(function (response)
                {
                    if (response.data.HasError)
                    {
                        reject(new Error('no results'));
                    }
                    else
                    {
                        resolve(response.data.Data);
                    }
                }, () =>
                {
                    reject(new Error('no results'));
                });
            });
        },
        getApplicationDetail (context, payload)
        {
            return new Promise(function (resolve, reject)
            {
                Vue.axios.get(Config.GetUrl(Config.kritaApi) + 'application/' +  payload.id,{
                }).then(function (response)
                {
                    if (response.data.HasError)
                    {
                        reject(new Error('no results'));
                    }
                    else
                    {
                        resolve(response.data.Data);
                    }
                }, () =>
                {
                    reject(new Error('no results'));
                });
            });
        },
        approveApplication (context, payload)
        {
            return new Promise(function (resolve, reject)
            {
                Vue.axios.post(Config.GetUrl(Config.kritaApi) + 'application/' + payload.id + '/ConfirmApplicationOffer', {}, {
                }).then(function (response)
                {
                    if (response.data.HasError)
                    {
                        reject(new Error('no results'));
                    }
                    else
                    {
                        resolve(response);
                    }
                }, () =>
                {
                    reject(new Error('no results'));
                });
            });
        },
        cancelApplication (context, payload)
        {
            let self = this;
            return new Promise(function (resolve, reject)
            {
                Vue.axios.post(Config.GetUrl(Config.kritaApi) + 'application/' + payload.id + '/CancelApplicationOffer', {}, {
                }).then(function (response)
                {
                    if (response.data.HasError)
                    {
                        reject(new Error('no results'));
                    }
                    else
                    {
                        resolve(response);
                    }
                }, () =>
                {
                    reject(new Error('no results'));
                });
            });
        },
        removesFactoringFromApplication (context, payload)
        {
            return new Promise(function (resolve, reject)
            {
                Vue.axios.delete(Config.GetUrl(Config.kritaApi) + 'application/' + payload.applicationId + '/claimantremovesfactoringfromapplication/?factoringId=' + payload.factoringId, {
                }).then(function (response)
                {
                    if (response.data.HasError)
                    {
                        reject(new Error('no results'));
                    }
                    else
                    {
                        resolve(response);
                    }
                }, () =>
                {
                    reject(new Error('no results'));
                });
            });
        },
    }
}
